import { render, staticRenderFns } from "./CorporateCulture.vue?vue&type=template&id=54a38d3a&scoped=true"
import script from "./CorporateCulture.vue?vue&type=script&lang=js"
export * from "./CorporateCulture.vue?vue&type=script&lang=js"
import style0 from "./CorporateCulture.vue?vue&type=style&index=0&id=54a38d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a38d3a",
  null
  
)

export default component.exports